// SPDX-License-Identifier: AGPL-3.0-or-later
// KONVO: one-line `action.done` hooks for code that should not know about channels or areas.

import Channels from '@app/features/channel/state/Channels';
import Activity from '@app/features/konvo_activity/state/Activity';
import {FLUXERBOT_ID} from '@fluxer/constants/src/AppConstants';
import {ChannelTypes} from '@fluxer/constants/src/ChannelConstants';

/** A Konvo message was sent: which kind of conversation, and whether it was a reply. */
export function trackMessageSent(channelId: string, reply: boolean): void {
	const channel = Channels.getChannel(channelId);
	const assistant = channel?.type === ChannelTypes.DM && channel.recipientIds.includes(FLUXERBOT_ID);
	const kind = !channel
		? null
		: channel.type === ChannelTypes.DM
			? 'dm'
			: channel.type === ChannelTypes.GROUP_DM
				? 'group'
				: 'channel';
	Activity.track('action.done', {
		area: assistant ? 'assistant' : 'chats',
		action: reply ? 'reply' : 'send',
		origin: 'konvo',
		...(kind ? {kind} : {}),
	});
}
